if (document.getElementById("vue-menu")) {
  new Vue({
      delimiters: ["[[", "]]"],
      el: '#vue-menu',
      props: {
      },
      data() {
          return {
            isOpen: false
          }
      },
      mounted() {
        console.log('mounted')
        this.initMenu()
      },
      methods: {
        handleClick(event) {
          const wrapper = document.querySelector('.js-sub-menu-wrapper')
          wrapper.classList.add('is-active')
          const target = event.currentTarget.dataset.target;
          const element = document.getElementById(target);
          element.classList.add('is-active')
        },

        initMenu() {
          menuItem = document.querySelectorAll('.js-menu-item')
          menuItem.forEach((element) => {
            element.addEventListener('click', (event) => {
              event.preventDefault()
              const wrapper = document.querySelector('.js-sub-menu-wrapper')
              wrapper.classList.add('is-active')
              const target = event.currentTarget.dataset.target;
              const element = document.getElementById(target);
              let left = '50%';
              if (['nav-team', 'nav-international', 'nav-news'].includes(target)) {
                const left_position = event.currentTarget.getBoundingClientRect().left + event.currentTarget.getBoundingClientRect().width / 2;
                left = left_position + 'px';
              }
              element.style.left = left;
              setTimeout(() => {
                element.classList.add('is-active')
              }, 300)
            })
          })

          submenus = document.querySelectorAll('.js-sub-menu');
          submenus.forEach((element) => {
            element.addEventListener('click', (event) => {
              event.stopPropagation()
            })
          })

          submenuWrapper = document.querySelector('.js-sub-menu-wrapper');
          submenuWrapper.addEventListener('click', (event) => {
            event.preventDefault()
            submenuWrapper.classList.remove('is-active')
            const activeSubMenu = document.querySelector('.js-sub-menu.is-active');
            activeSubMenu.classList.remove('is-active')
          })

          closeButton = document.querySelectorAll('.js-close-sub-menu')
          closeButton.forEach((element) => {
            element.addEventListener('click', (event) => {
              event.preventDefault()
              event.preventDefault()
              submenuWrapper.classList.remove('is-active')
              const activeSubMenu = document.querySelector('.js-sub-menu.is-active');
              activeSubMenu.classList.remove('is-active')
            })
          })
        }
      }
  })
}
